import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { HeadingComponent, TruncateComponent } from '@recruitee/user-interface';
import { AnyGroup, LayoutBoardGroupHeader } from '@recruitee/views-types';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rt-default-group-header',
  styleUrls: ['./default-group-header.component.less'],
  imports: [HeadingComponent, TruncateComponent],
  template: `
    <rt-heading variant="heading text-color">
      <rt-truncate>{{ group.label }}</rt-truncate>
    </rt-heading>
  `,
})
export class DefaultGroupHeaderComponent implements LayoutBoardGroupHeader {
  @Input() public group: AnyGroup;
  @Input() public selectionInGroup: 'indeterminate' | 'all' | null;
  @Output() public select = new EventEmitter<AnyGroup>();
}
